import { baseApi } from '@Services/api';
import { RequestTypes } from '@Constants/api';

const DashboardApis = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getDashboardMetrics: builder.query({
            query: (payload) => ({
                url: '/v0/dashboard/metric',
                method: RequestTypes.GET,
                params: payload,
            })
        })
    })
});

export const { useLazyGetDashboardMetricsQuery } = DashboardApis;
